module.exports = __webpack_public_path__ + "assets/img/more_app.41c3cef0.png";